export default "__VITE_ASSET__VTBeXS$B__"